exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LinkButton__link__2OxTI{text-decoration:none;color:initial}.LinkButton__button__3Zmk1{padding:0!important}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/buttons/src/components/controls/buttons/LinkButton.scss"],"names":[],"mappings":"AAEA,yBACE,qBAAqB,AACrB,aAAc,CACf,AAED,2BACE,mBAAqB,CACtB","file":"LinkButton.scss","sourcesContent":["@import '../../../styles/theme.scss';\n\n.link {\n  text-decoration: none;\n  color: initial;\n}\n\n.button {\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"link": "LinkButton__link__2OxTI",
	"button": "LinkButton__button__3Zmk1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/buttons/LinkButton.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/buttons/LinkButton.scss
// module chunks = 0